import { ReactNode } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/types";

const CustomTooltip = ({ id, children, title, placement }: { id: string, children: any, title: string | ReactNode, placement: Placement }) => (
    <OverlayTrigger
        placement={placement}
        overlay={<Tooltip id={id} style={{ position: "fixed" }}>{title}</Tooltip>}
    >
        {children}
    </OverlayTrigger>
);

export default CustomTooltip;